import React from 'react'
import { Button, DropdownMenu, Flex, useAppTheme } from '@workwhile/ui'
import { EllipsisVertical, Pencil, Trash2 } from 'lucide-react'
import { createGlobalStyle } from 'styled-components'
import { BillRate } from '../types'
import { useBillRatesWorkflowsContextValue } from '../context/BillRatesWorkflowsProvider'

// Fix the z-index of the dropdown menu to appear above the table
// Radix poppers render in a portal, so we need a global style to fix the z-index
const DropdownZIndexFix = createGlobalStyle`
  [data-radix-popper-content-wrapper] {
    z-index: 100 !important;
  }
`

export const ActionsCell = ({ billRate }: { billRate: BillRate }) => {
  const { space } = useAppTheme()
  const { editBillRateFlow, deleteBillRateFlow } =
    useBillRatesWorkflowsContextValue()

  return (
    <>
      <DropdownZIndexFix />
      <Flex justifyContent="center" alignItems="center" width="100%">
        <DropdownMenu
          trigger={
            <Button
              variant="secondary"
              kind="small"
              style={{ paddingLeft: space[1], paddingRight: space[1] }}
            >
              <EllipsisVertical size={14} />
            </Button>
          }
        >
          <DropdownMenu.Item onClick={() => editBillRateFlow.open(billRate)}>
            <Flex as="span" alignItems="center" style={{ gap: 8 }}>
              <Pencil size={14} />
              Edit bill rate
            </Flex>
          </DropdownMenu.Item>
          <DropdownMenu.Item onClick={() => deleteBillRateFlow.open(billRate)}>
            <Flex as="span" alignItems="center" style={{ gap: 8 }}>
              <Trash2 size={14} />
              Deactivate bill rate
            </Flex>
          </DropdownMenu.Item>
        </DropdownMenu>
      </Flex>
    </>
  )
}
